import React from "react";
import { FormControl } from "../FormControl";
import { PropertyEditorColor } from "../../../CommonUI/PropertyEditing/PropertyEditorColor";
import { PropertyEditorInteger } from "../../../CommonUI/PropertyEditing/PropertyEditorInteger";
import { ValidationIssue } from "../../../rule-engine-core/Common/IDesignValidationProvider";
import { IDataDefinition } from "../../../rule-engine-core/Common/Data/Definitions/IDataDefinition";
import { PropertyEditorBoolean } from "../../../CommonUI/PropertyEditing/PropertyEditorBoolean";
import { DataUtilities } from "../../../rule-engine-core/Common/DataUtilities";
import { PropertyEditorCollapse } from "../../../CommonUI/PropertyEditing/PropertyEditorCollapse";
import { UISpacedBoxContent } from "../../../CommonUI/BuildlingBlocks/UISpacedBoxContent";
import { UIStyleConstants } from "../../../rule-engine-core/Common/UIStyleConstants";

export class LineFormControl extends FormControl {
    readonly __type: string = "Line";
    width?: number;
    color?: string = UIStyleConstants.GRAY_DARK_COLOR;
    height?: number = 3;
    borderRadius?: number;
    marginTop?: number;
    marginBottom?: number;

    marginY: number = 0;

    sameMargin: boolean = true;

    fullWidth: boolean = true;

    constructor() {
        super();
        this.canFocus = false;
    }

    render() {
        const styleHr = {
            width: this.fullWidth ? "100%" : this.width,
            color: this.color,
            backgroundColor: this.color,
            height: this.height,
            border: "none",
            borderRadius: this.borderRadius,
            marginTop: this.sameMargin ? this.marginY : this.marginTop,
            marginBottom: this.sameMargin ? this.marginY : this.marginBottom,
            marginLeft: "auto",
            marginRight: "auto",
        };
        return (
            <hr
                style={styleHr}
                data-testid="hrTag"
            />
        );
    }

    renderEditUI(): JSX.Element | null {
        return <XLineControlUI editMe={this} />;
    }

    getDesignValidationIssues(): ValidationIssue[] {
        return [];
    }

    getRuntimeValidationIssues(): ValidationIssue[] {
        return [];
    }

    getAddedData(): IDataDefinition | IDataDefinition[] | undefined {
        return;
    }

    getStorageData(): object {
        let retData = super.getStorageData();

        retData = DataUtilities.addStorageData(
            this,
            retData,
            "__type",
            "width",
            "color",
            "height",
            "borderRadius",
            "marginTop",
            "marginBottom",
            "marginY",
            "sameMargin",
            "fullWidth",
        );

        return retData;
    }

    setStorageData(data: object): void {
        super.setStorageData(data);

        DataUtilities.setStorageData(
            this,
            data,
            "__type",
            "width",
            "color",
            "height",
            "borderRadius",
            "marginTop",
            "marginBottom",
            "marginY",
            "sameMargin",
            "fullWidth",
        );
    }
}

export function XLineControlUI(props: { editMe: LineFormControl }) {
    return (
        <UISpacedBoxContent>
            <PropertyEditorBoolean
                label={"Same Margin Top and Bottom"}
                propertyName={"sameMargin"}
                editObject={props.editMe}
            />

            <PropertyEditorCollapse
                editObject={props.editMe}
                collapseLogicOrField={"sameMargin"}
            >
                <PropertyEditorInteger
                    label={"Margin"}
                    propertyName={"marginY"}
                    editObject={props.editMe}
                />
            </PropertyEditorCollapse>
            <PropertyEditorCollapse
                editObject={props.editMe}
                collapseLogicOrField={"sameMargin"}
                showIfFalse={true}
            >
                <PropertyEditorInteger
                    label={"Margin Top"}
                    propertyName={"marginTop"}
                    editObject={props.editMe}
                />
                <PropertyEditorInteger
                    label={"Margin Bottom"}
                    propertyName={"marginBottom"}
                    editObject={props.editMe}
                />
            </PropertyEditorCollapse>
            <PropertyEditorBoolean
                label="Full width"
                propertyName={"fullWidth"}
                editObject={props.editMe}
            />
            <PropertyEditorCollapse
                editObject={props.editMe}
                collapseLogicOrField={"fullWidth"}
                showIfFalse={true}
            >
                <PropertyEditorInteger
                    label={"Width"}
                    propertyName={"width"}
                    editObject={props.editMe}
                />
            </PropertyEditorCollapse>
            <PropertyEditorInteger
                label={"Height"}
                propertyName={"height"}
                editObject={props.editMe}
            />
            <PropertyEditorInteger
                label={"Border Radius"}
                propertyName={"borderRadius"}
                editObject={props.editMe}
            />
            <PropertyEditorColor
                editObject={props.editMe}
                label={"Color"}
                propertyName={"color"}
            />
        </UISpacedBoxContent>
    );
}
